import { useState, useEffect } from 'react';
import Navbar from '../Navbar';
import Footer from '../Footer'

function Project_Suit() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <main className='px-8 md:px-20 lg:px-40'>
    
    <Navbar />

    <section id='home' className='mt-40 flex flex-col max-w-screen-md mx-auto text-justify'>
        <h1 id='title' className='text-2xl md:text-3xl font-medium text-teal-500'>A High-resolution Haptic Suit for Immersive Tactile Experience (In Progress)</h1>
        <h3 id='authors' className='text-lg mt-10 md:text-xl'>Bingjian Huang, Siyi Ren, Yuewen Luo, Qilong Cheng, Hanfeng Cai, Yeqi Sang, Mauricio Sousa, Paul H. Dietz, Daniel Wigdor</h3>
    </section>
    <section id='content' className='mt-10 max-w-screen-md mx-auto text-justify' >
        <p className='text-lg mt-3'>
        Spatialized vibrotactile feedback systems deliver tactile information by placing multiple vibrotactile actuators on the body. As increasing numbers of actuators are required to adequately convey information in complicated applications, haptic designers find it difficult to create such systems due to limited scalability of existing toolkits. We propose VibraForge, an open-source vibrotactile toolkit that supports up to 128 vibrotactile actuators. Each actuator is encapsulated within a self-contained vibration unit and driven by its own microcontroller. By leveraging a chain-connection method, each unit receives independent vibration commands from a control unit, with fine-grained control over intensity and frequency. We also designed a GUI Editor to expedite the authoring of spatial vibrotactile patterns. Technical evaluations show that vibration units reliably reproduce audio waveforms with low-latency and high-bandwidth data communication. Case studies of phonemic tactile display, virtual reality fitness training, and drone teleoperation demonstrate the potential usage of VibraForge within different domains.
        </p>
    </section>
    <section id='content' className='mt-10 max-w-screen-md mx-auto text-justify' >
        <div>
        <iframe width="720" height="480" src="https://www.youtube.com/embed/BGc5lPs--7M?si=V2wKr-TTvoxnjtoH" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
        </div>
    </section>
    <section id='content' className='min-h-screen mt-10 max-w-screen-md mx-auto text-justify' >
        <div id='image' className='mt-10 flex'>
          <p className='text-md mt-3'>System Pipeline</p>
          <img src='project_suit_system_architecture.png' layout="fill" objectFit="cover" />      
        </div>
        <div id='image' className='mt-10 flex'>
          <p className='text-md mt-3'>Suit Design: Chain-topology Connections</p>
          <img src='project_suit_overall_design.png' layout="fill" objectFit="cover" />      
        </div>
        <div id='image' className='mt-10 flex'>
          <p className='text-md mt-3'>Motor Designs</p>
          <div className='w-1/2 ml-4'>
            <img src='exploded_view_1.png' layout="fill" objectFit="cover" />
          </div>
          <div className='w-1/2 ml-4'>
            <img src='exploded_view_2.png' layout="fill" objectFit="cover" />
          </div>
        </div>
        <div id='image' className='mt-10 flex'>
          <p className='text-md mt-3'>Backpack Designs</p>
          <div className='w-1/3 ml-4'>
            <img src='project_suit_backpack_design1.png' layout="fill" objectFit="cover" />
          </div>
          <div className='w-1/3 ml-4'>
            <img src='project_suit_backpack_design3.png' layout="fill" objectFit="cover" />
          </div>
          <div className='w-1/3 ml-4'>
            <img src='project_suit_backpack_design2.png' layout="fill" objectFit="cover" />
          </div>
        </div>
        <div id='image' className='mt-10 flex'>
          <p className='text-md mt-3'>Potential Applications</p>
        </div>
        <div>
          <p className='text-md mt-3'>VR Social Interaction with Touch</p>
          <img src='project_suit_social_touch.png' layout="fill" objectFit="cover" />  
        </div>
        <div>
          <p className='text-md mt-3'>VR Fitness training</p>
          <img src='project_suit_shooting_game.png' layout="fill" objectFit="cover" />      
        </div>
        <div>
          <p className='text-md mt-3'>VR Shooting Game</p>
          <img src='project_suit_vr_fitness.jpg' layout="fill" objectFit="cover" />          
        </div>

    </section>

    <Footer />

    </main>
  );
}

export default Project_Suit;
